import { styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';

import LevelCircularProgress from '../level-circular-progress/level-circular-progress';

export interface ProgressCirclesProps {
  liveClassProgressPercent: number;
  liveClassTaken: number;
  liveClassRequired: number;

  unitProgressPercent: number;
  unitTaken: number;
  unitRequired: number;

  practiceProgressPercent: number;
  practiceTaken: number;
  practiceRequired: number;

  labels: {
    liveClasses: string;
    units: string;
    practices: string;
    practicesMaxValue: string;
    of: string;
  };
}

const CIRCLE_SIZE = 150;

export const ProgressCircles = ({
  liveClassProgressPercent,
  liveClassTaken,
  liveClassRequired,
  unitProgressPercent,
  unitTaken,
  unitRequired,
  practiceProgressPercent,
  practiceTaken,
  labels,
}: ProgressCirclesProps) => {
  const circleCommonProps = {
    ofLabel: labels.of,
    width: 8,
    backgroundWidth: 5,
    size: CIRCLE_SIZE,
    valueFontSize: 42,
    maxValueFontSize: 24,
  };

  return (
    <Container>
      <Line />
      <Content>
        <LiveClassesCircle
          fill={liveClassProgressPercent}
          currentValue={liveClassTaken}
          maxValue={liveClassRequired}
          description={labels.liveClasses}
          {...circleCommonProps}
        />
        <UnitsCircle
          fill={unitProgressPercent}
          currentValue={unitTaken}
          maxValue={unitRequired}
          description={labels.units}
          {...circleCommonProps}
        />
        <PracticesCircle
          fill={practiceProgressPercent}
          currentValue={practiceTaken}
          maxValue={labels.practicesMaxValue}
          description={labels.practices}
          {...circleCommonProps}
        />
      </Content>
    </Container>
  );
};

const LiveClassesCircle = styled(LevelCircularProgress).attrs(({ theme }) => ({
  tintColor: theme.color.primary,
}))``;

const UnitsCircle = styled(LevelCircularProgress).attrs(({ theme }) => ({
  tintColor: theme.color.olive,
}))``;

const PracticesCircle = styled(LevelCircularProgress).attrs(({ theme }) => ({
  tintColor: theme.color.fuxia,
}))``;

const Container = styled.View`
  flex-direction: row;
  width: 630px;
  min-height: 185px;
`;

const Line = styled.View`
  background-color: ${({ theme }) => theme.color.border};
  height: 1px;
  width: 100%;
  margin-top: ${CIRCLE_SIZE / 2}px;
`;

const Content = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-horizontal: 24px;
  position: absolute;
  left: 0;
  right: 0;
`;

export default memo(ProgressCircles);
